// extracted by mini-css-extract-plugin
export default {"noticeWrapper":"PayoutDetailsNotice_noticeWrapper__ZDqbC","noticeText":"PayoutDetailsNotice_noticeText__x+-EH","resolveLink":"PayoutDetailsNotice_resolveLink__MACa5"};